/**
 * Mirror of backend `multipart-filename.ts`.
 * Repairs names already stored from Multer's latin1 reading of a UTF-8 filename.
 * A correct name (typed in the browser, or already repaired) is returned as-is.
 *
 * `escape` / `unescape` treat the string as latin1 bytes, which is what Multer stored.
 * They stay available in the browsers this app supports and in the Jest jsdom runtime.
 */
export function decodeMultipartFilename(name) {
  if (!name) {
    return '';
  }
  try {
    const decoded = decodeURIComponent(escape(name));
    const roundTrip = unescape(encodeURIComponent(decoded));
    return roundTrip === name ? decoded : name;
  } catch {
    return name;
  }
}
